import React, { useState } from "react";
import styles from "./styles/OutputLocation.module.css";
import { NavLink } from "react-router-dom";
import { removeWhiteSpace } from "../../../utils/utils";
import { ReactComponent as IconLocation } from "../../../assets/location.svg";
/**
 * Location output component
 *
 */
const OutputLocation = ({ label, data, location, ticketNumber }) => {
    const main = (
        <>
            <div className={`${styles.icon_container} flex-container`}>
                <IconLocation className={` ${styles.icon} icon-component`} />
            </div>

            <div className={`${styles.output_data} flex-container`}>
                <p>{data}</p>
            </div>
        </>
    );

    return (
        <div className={`${styles.main_output_container} v-flex-container`}>
            <div className={`${styles.output_label}`}>{label}</div>
            {location ? (
                <NavLink
                    className={`${styles.output_container} ${styles.location} flex-container`}
                    target="_blank"
                    rel="noreferrer"
                    to={`https://www.google.com/maps/search/?api=1&query=${removeWhiteSpace(
                        location
                    )}`}
                    aria-label={`location for ticket number ${ticketNumber}`}
                >
                    {main}
                </NavLink>
            ) : (
                <div
                    className={`${styles.output_container} ${styles.no_location} flex-container`}
                    aria-label={`address for ticket number ${ticketNumber}`}
                >
                    {main}
                </div>
            )}
        </div>
    );
};

export default OutputLocation;
